import React, { useContext, } from 'react';
import { Button, Row, Space, Form } from 'antd';
import { EditOutlined, } from '@ant-design/icons';
import { PermissionsContext } from '../../../../router/DashboardRoutes';

export const EditSerialNumButton = ({devicePending, serialNum, modal, ...children }) => {

    const userPermissions = useContext(PermissionsContext);
    const isPCI = userPermissions.server.pci;
    const allowEditDevice = userPermissions.device.edit;

    return (
        <Form.Item 
            label="Serial Number:" 
            name='serialNum' 
            tooltip={devicePending ? "Serial number can't be updated. Pending changes must be cleared." : null}
            >
            <Button
                style={{
                    width: '100%', 
                    display: 'flex', 
                    justifyContent: 'flex-start', 
                    alignItems: 'center',
                    ...children?.style
                }}
                onClick={(!devicePending && allowEditDevice) ? children?.onClick : undefined}
                disabled={ devicePending || !allowEditDevice }
                >
                <Row align='middle'>
                    <Space>
                        {serialNum}
                        {allowEditDevice && <EditOutlined/>}
                    </Space>
                </Row>
            </Button>
        </Form.Item>
    )
}

EditSerialNumButton.defaultProps = {
    pending: true, 
}